import hardware from './hardware.prod'

const commonPlanProperties = {
    group_key: 'pro',
    label: 'Travel Ball',
    description: 'Travel Ball',
    stripe_product_id: 'prod_PUBLkEXMKaP6AU',
    badge: '',
    free_hardware: true,
    free_hardware_categories: ['bat_attachment'],
    includes_coaching: false,
    hardware_options: hardware.filter(h => h.category === 'bat_attachment' && h.price === 0),
    is_travel_ball: true,
}

const monthlyPlan = {
    ...commonPlanProperties,
    map_key: 'pro_monthly',
    billing_interval: 'monthly',
    price: 3900,
    price_monthly: 3900,
}

const yearlyPlan = {
    ...commonPlanProperties,
    map_key: 'pro_yearly',
    billing_interval: 'yearly',
    price: 35500,
    price_monthly: 2958,
}

export default {
    'power-baseball': {
        name: 'Power Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OfCytIDrm6Z6HgYm5S1ugU2',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrSIXIDrm6Z6HgYZEhQ4vZH',
            } as StripePlan,
        ],
    },
    'slammers': {
        name: 'Slammers',
        coupon: 'slammers1',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OgsSAIDrm6Z6HgYdS97BIdQ',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            // {
            //     ...yearlyPlan,
            //     stripe_price_id: 'price_1OrSIiIDrm6Z6HgYjWMWJOfY',
            // } as StripePlan,
        ],
    },
    'dulins-dodgers': {
        name: 'Dulins Dodgers',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P5aUEIDrm6Z6HgYkAG4zeH2',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrSIxIDrm6Z6HgYUt2zobsU',
            } as StripePlan,
        ],
    },
    'iowa-sticks': {
        name: 'Iowa Sticks',
        coupon: 'iowasticks1',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OjOpvIDrm6Z6HgYvoswpX9A',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
        ],
    },
    'marucci-elite': {
        name: 'Marucci Elite',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OmO3sIDrm6Z6HgYbzPlrVsy',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrSJrIDrm6Z6HgYI0R9b1k2',
            } as StripePlan,
        ],
    },
    'hunter-pence': {
        name: 'Hunter Pence',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OlxmDIDrm6Z6HgYVAPsZjom',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrSJcIDrm6Z6HgYABuPrKgv',
            } as StripePlan,
        ],
    },
    'east-coast-development': {
        name: 'East Coast Sox',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1Olxm0IDrm6Z6HgYnT8FLgN7',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrSJQIDrm6Z6HgYgW4ikRyV',
            } as StripePlan,
        ],
    },
    'p2p-millers': {
        name: 'P2P Millers',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1Oo7XaIDrm6Z6HgY27mLLW6R',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrSK6IDrm6Z6HgYpZ4V7YD5',
            } as StripePlan,
        ],
    },
    'twelve-degree-launch': {
        name: 'Twelve Degree Launch',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OrNDEIDrm6Z6HgYPWjt7AxN',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrSKOIDrm6Z6HgYOFCJB4cV',
            } as StripePlan,
        ],
    },
    '5-star': {
        name: '5 Star',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1Os8hlIDrm6Z6HgYGJjxfH1q',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1Os8iAIDrm6Z6HgYOUxMkWsE',
            } as StripePlan,
        ],
    },
    'east-cobb': {
        name: 'East Cobb',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OtFbMIDrm6Z6HgYiczfPVNV',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OtFbYIDrm6Z6HgYkfHku6KY',
            } as StripePlan,
        ],
    },
    'exposure': {
        name: 'eXposure',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXVYIDrm6Z6HgYqteI7lBf',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXViIDrm6Z6HgY13f3t2d7',
            } as StripePlan,
        ],
    },
    'cba': {
        name: 'CBA',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXVuIDrm6Z6HgYvgHtjUXa',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXW3IDrm6Z6HgYyvNsOvi5',
            } as StripePlan,
        ],
    },
    'hardcore-elite': {
        name: 'Hardcore Elite',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXWEIDrm6Z6HgYrHbvlESD',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXWPIDrm6Z6HgYd50kVPlu',
            } as StripePlan,
        ],
    },
    'lonestar': {
        name: 'Lonestar',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXXCIDrm6Z6HgYU78BrYex',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXXOIDrm6Z6HgYYMvdWWMS',
            } as StripePlan,
        ],
    },
    '3-step': {
        name: '3 Step',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXXtIDrm6Z6HgYKfbqsmiL',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXY9IDrm6Z6HgYZgWLRQIC',
            } as StripePlan,
        ],
    },
    'knights-knation': {
        name: 'Knights Knation',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXYKIDrm6Z6HgYxjWya9EP',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXYUIDrm6Z6HgYNYGoHBIl',
            } as StripePlan,
        ],
    },
    'grb-rays': {
        name: 'GRB Rays',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXYhIDrm6Z6HgYN9oQ62HO',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXYrIDrm6Z6HgYlOSdxKCv',
            } as StripePlan,
        ],
    },
    'gbg': {
        name: 'GBG',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXZ0IDrm6Z6HgY8OxFhODY',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXZ9IDrm6Z6HgYrykso14C',
            } as StripePlan,
        ],
    },
    'ebc': {
        name: 'EBC',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXZJIDrm6Z6HgY6KdgNkr8',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXZRIDrm6Z6HgY6YOoFr6N',
            } as StripePlan,
        ],
    },
    'team-elite': {
        name: 'Team Elite',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXrPIDrm6Z6HgYrKWq5Icc',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXraIDrm6Z6HgYzW3ZVi9c',
            } as StripePlan,
        ],
    },
    'indiana-bulls': {
        name: 'Indiana Bulls',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXrwIDrm6Z6HgYi4H0LmZZ',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXs7IDrm6Z6HgYB61E3svM',
            } as StripePlan,
        ],
    },
    'select1': {
        name: 'WIN Player Development Program',
        alias: 'All Star Sports Academy',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXsOIDrm6Z6HgYXjiPVLdP',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXsXIDrm6Z6HgYjz1W72aR',
            } as StripePlan,
        ],
    },
    'the-show-new-england': {
        name: 'The Show New England',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXXZIDrm6Z6HgYodpK6JJ7',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXXkIDrm6Z6HgYsETj23DP',
            } as StripePlan,
        ],
    },
    'noreasters': {
        name: 'Nor\'Easters',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzPQkIDrm6Z6HgYNqTik79S',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzPQvIDrm6Z6HgYXqB5mWoI',
            } as StripePlan,
        ],
    },
    'prospects-athletics': {
        name: 'Prospects Athletics',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzPR4IDrm6Z6HgYIe3YF1NY',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzPRLIDrm6Z6HgYPx6JdkvJ',
            } as StripePlan,
        ],
    },
    'bay-sox': {
        name: 'Bay Sox',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzPRXIDrm6Z6HgYNZGlGATU',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzPRhIDrm6Z6HgYw45yMWgc',
            } as StripePlan,
        ],
    },
    'seacoast': {
        name: 'Seacoast',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzPRrIDrm6Z6HgY7pFHjzQQ',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzPS4IDrm6Z6HgYRu9TCieQ',
            } as StripePlan,
        ],
    },
    'northeast-hurricanes': {
        name: 'Northeast Hurricanes',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzPSQIDrm6Z6HgY2sQ69yXc',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzPSaIDrm6Z6HgYIgNJENr6',
            } as StripePlan,
        ],
    },
    'midland': {
        name: 'Midland',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzPSlIDrm6Z6HgY56PgRetW',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzPSvIDrm6Z6HgYOZTj8bKi',
            } as StripePlan,
        ],
    },
    'grb-stiks': {
        name: 'GRB STiKS',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P2HiTIDrm6Z6HgYC64vIgBc',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P2HidIDrm6Z6HgYnNJIJJ56',
            } as StripePlan,
        ],
    },
    'grb-illinois': {
        name: 'GRB Illinois',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P2HilIDrm6Z6HgYpvQ7uFbz',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P2HiuIDrm6Z6HgYUUNkIip4',
            } as StripePlan,
        ],
    },
    'grb-northstar': {
        name: 'GRB Northstar',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P2HjAIDrm6Z6HgYPLYBv8JH',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P2HjIIDrm6Z6HgYQAafKWJ9',
            } as StripePlan,
        ],
    },
    'grb-dakota-select': {
        name: 'GRB Dakota Select',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P2HjWIDrm6Z6HgYBWxCqOXb',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P2HjnIDrm6Z6HgYrqQiHqva',
            } as StripePlan,
        ],
    },
    'clubhouse-ct': {
        name: 'Clubhouse CT',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3n7NIDrm6Z6HgYinlxEbgF',
                price: 9900,
                price_monthly: 9900,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3n7ZIDrm6Z6HgYTOpAzsBF',
                price: 99900,
                price_monthly: 8325,
            } as StripePlan,
        ],
    },
    'wildcats-baseball': {
        name: 'Wildcats Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3n7sIDrm6Z6HgY55q3rmq7',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3n84IDrm6Z6HgYP3aOE87p',
            } as StripePlan,
        ],
    },
    'original-florida-pokers': {
        name: 'Original Florida Pokers',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3n8RIDrm6Z6HgYTYqXesUh',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3n8eIDrm6Z6HgYZiYqaXQK',
            } as StripePlan,
        ],
    },
    'midland-marlins': {
        name: 'Midland Marlins',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3n8zIDrm6Z6HgYa72hdWuR',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3n99IDrm6Z6HgYapVU23nk',
            } as StripePlan,
        ],
    },
    'cooperstown-cobras': {
        name: 'Cooperstown Cobras',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3n9QIDrm6Z6HgYsrPpyAb2',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3n9aIDrm6Z6HgYmjr1QWQu',
            } as StripePlan,
        ],
    },
    'canes': {
        name: 'Canes',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3pPmIDrm6Z6HgYHbAK0Qtv',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3pPyIDrm6Z6HgYiqH87Lht',
            } as StripePlan,
        ],
    },
    'd-bat': {
        name: 'D-Bat',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3pQ6IDrm6Z6HgYQ9jQT5mT',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3pQGIDrm6Z6HgYeuoL0Q9g',
            } as StripePlan,
        ],
    },
    'select2': {
        name: 'WIN Player Development Program',
        alias: 'Tim Dulin',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P5afCIDrm6Z6HgYc0e3nwhh',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P5afMIDrm6Z6HgYTOrvfmvA',
            } as StripePlan,
        ],
    },
    'select3': {
        name: 'WIN Player Development Program',
        alias: 'Baseball USA',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P6bAPIDrm6Z6HgY6E2IlB7S',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P6bAZIDrm6Z6HgYjNO302eh',
            } as StripePlan,
        ],
    },
} as Record<string, Org>
